import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { Button } from '../../ui-kit/Button/Button.js';
import { style } from '../../utils/style.js';
export const renderSubmitButton = (button, className) => (_jsx(Button, { className: style('w-full @xl:w-auto', className), type: "submit", children: button?.text ? button.text : 'Отправить заявку' }));
//# sourceMappingURL=renderSubmitButton.js.map